// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3ISBQ","col":"Table_col__2Y8ei","fulfillmentStatus":"Table_fulfillmentStatus__Fiv0M","emailCol":"Table_emailCol__2gaxO"};